class EditorError extends Error {
    constructor(message, info, cause) {
        super(message);
        this.name = this.constructor.name;
        if (info) this.info = info;
        if (cause) this.cause = cause;
    }

    withInfo(info) {
        this.info = info;
        return this;
    }

    withCause(cause) {
        this.cause = cause;
        return this;
    }

    static tag(error, message, info) {
        const editorError = error;

        if (!editorError._editorErrorTags) editorError._editorErrorTags = [];

        let tag;
        if (Error.captureStackTrace) {
            tag = { name: "TaggedError", message, info };
            Error.captureStackTrace(tag, EditorError.tag);
        } else {
            tag = new TaggedError(message || "", info);
        }

        if (editorError._editorErrorTags.length >= EditorError.maxTags) {
            if (editorError._editorErrorTags[1] === DROPPED_TAGS_ERROR) {
                editorError._editorErrorTags.splice(2, 1);
            } else {
                editorError._editorErrorTags[1] = DROPPED_TAGS_ERROR;
            }
        }
        editorError._editorErrorTags.push(tag);

        return error;
    }

    static getFullInfo(error) {
        const info = {};

        if (!error) return info;

        const editorError = error;

        if (editorError.cause) Object.assign(info, EditorError.getFullInfo(editorError.cause));
        if (typeof editorError.info === "object") Object.assign(info, editorError.info);

        if (editorError._editorErrorTags) {
            for (const tag of editorError._editorErrorTags) {
                Object.assign(info, tag.info);
            }
        }

        return info;
    }

    static getFullStack(error) {
        if (!error) return "";

        const editorError = error;
        let stack = editorError.stack || editorError.message || "(no stack)";

        if (Array.isArray(editorError._editorErrorTags) && editorError._editorErrorTags.length) {
            stack += `\n${editorError._editorErrorTags.map((tag) => tag.stack).join("\n")}`;
        }

        const causeStack = EditorError.getFullStack(editorError.cause);
        if (causeStack) {
            stack += "\ncaused by:\n" + indent(causeStack);
        }

        return stack;
    }
}

EditorError.maxTags = 100;

class TaggedError extends EditorError {}

const DROPPED_TAGS_ERROR = {
    name: "TaggedError",
    message: "... dropped tags",
    stack: "TaggedError: ... dropped tags",
};

function indent(string) {
    return string.replace(/^/gm, "    ");
}

module.exports = EditorError;
module.exports.default = EditorError;
